"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronLeft = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ChevronLeft = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "chevron-left", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "chevron-left", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M20.293 28.293a1 1 0 0 0 1.414 0l1.586-1.586a1 1 0 0 0 0-1.414l-8.586-8.586a1 1 0 0 1 0-1.414l8.586-8.586a1 1 0 0 0 0-1.414l-1.586-1.586a1 1 0 0 0-1.414 0L8.707 15.293a1 1 0 0 0 0 1.414l11.586 11.586Z", fill: "#172344", fillRule: "evenodd" }) })) })));
};
exports.ChevronLeft = ChevronLeft;
